import ImgDefault from "../assets/svg/profileImg/profileImg.svg";
import ImgDefaultHover from "../assets/svg/profileImg/profileImgHover.svg";
import IconEdit from "../assets/svg/pen-icon-account.svg";
import IconDelete from "../assets/svg/icon-delete-show-account.svg";
import plus from "../assets/svg/profileImg/plus.svg";
import Document from "../assets/svg/tabsImg/Document.svg";
import DocumentShow from "../assets/svg/tabsImg/DocumentShow.svg";
import Location from "../assets/svg/tabsImg/Location.svg";
import LocationShow from "../assets/svg/tabsImg/LocationShow.svg";
import Calling from "../assets/svg/tabsImg/Calling.svg";
import CallingShow from "../assets/svg/tabsImg/CallingShow.svg";
import plusIcon from "../assets/svg/plus-table.svg";
import ImgLogoProduct from "../assets/svg/icon-logo-product.svg";
import {
  apiAddProducts,
  apiDeleteProducts,
  apiGetProduct,
  apiGetProducts,
  apiGetProductsExcel,
  apiUpdateProduct,
} from "../api/productApi";
import { apiGetCategoryExcel } from "../api/categoryApi";
import ProductPropertyTab from "./ProductPropertyTab";

const productTableColumns = [
  {
    name: "کد حسابداری",
    key: "accountingCode",
    filterParams: {
      column: "accountingCode",
      columnType: "string",
    },
  },
  {
    name: "دسته بندی",
    key: "category",
    filterParams: {
      subColumn: "category",
      columnType: "string",
      relationColumn: "title",
    },
    // searchType: "autocomplete",
    // dataKey: {
    //   column: "productCategories",
    //   key: "title",
    // },
  },
  {
    name: "نام",
    key: "title",
    filterParams: {
      column: "title",
      columnType: "string",
    },
    navigate: "/reports/productsAccountCard?productId=",
    // searchType: "autocomplete",
    // dataKey: {
    //   column: "products",
    //   key: "title",
    // },
  },
  {
    name: "کد کالا",
    key: "code",
    filterParams: {
      column: "code",
      columnType: "string",
    },
  },
  {
    name: "بارکد",
    key: "barcode",
    filterParams: {
      column: "id",
      columnType: "string",
      relationModelName: "ProductBarcode",
      relationColumn: "barcode",
      relationModelKey: "ProductId",
    },
    getValue: (item) => {
      let barcode = "";
      item?.Barcodes?.map((b) => (barcode += (barcode.length > 0 ? "; " : "") + b.barcode));
      return barcode.length > 0 ? barcode : "-";
    },
  },
  {
    name: "واحد اصلی",
    key: "unit",
    filterParams: {
      column: "unit",
      columnType: "string",
    },
  },
  {
    name: "واحد فرعی",
    key: "subUnit",
    filterParams: {
      column: "subUnit",
      columnType: "string",
    },
  },
  {
    name: "قیمت فروش",
    key: "sellPrice",
    price: true,
    filterParams: {
      column: "sellPrice",
      columnType: "number",
    },
    searchType: "quantitative",
  },
  {
    name: "قیمت خرید",
    key: "buyPrice",
    price: true,
    filterParams: {
      column: "buyPrice",
      columnType: "number",
    },
    searchType: "quantitative",
  },
  // {
  //   name: "موجودی حسابداری",
  //   key: "count",
  //   price: true,
  //   disableSearch: true,
  //   Component: NumberComponent,
  //   filterParams: {
  //     column: "count",
  //     columnType: "number",
  //   },
  //   searchType: "quantitative",
  // },
  // {
  //   name: "موجودی انبار",
  //   key: "productCount",
  //   price: true,
  //   disableSearch: true,
  //   Component: NumberComponent,
  //   filterParams: {
  //     column: "productCount",
  //     columnType: "number",
  //   },
  //   searchType: "quantitative",
  // },
];

const serviceTableColumns = [
  {
    name: "کد حسابداری",
    key: "accountingCode",
    filterParams: {
      column: "accountingCode",
      columnType: "string",
    },
  },
  {
    name: "دسته بندی",
    key: "category",
    filterParams: {
      column: "CategoryId",
      columnType: "string",
      relationModelName: "ProductCategory",
      relationColumn: "title",
    },
    // searchType: "autocomplete",
    // dataKey: {
    //     column: "productCategories",
    //     key: "title",
    // },
  },
  {
    name: "نام",
    key: "title",
    filterParams: {
      column: "title",
      columnType: "string",
    },
    navigate: "/reports/productsAccountCard?productId=",
    // searchType: "autocomplete",
    // dataKey: {
    //     column: "products",
    //     key: "title",
    // },
  },
  {
    name: "واحد اصلی",
    key: "unit",
    filterParams: {
      column: "unit",
      columnType: "string",
    },
  },
  {
    name: "قیمت فروش",
    key: "sellPrice",
    price: true,
    filterParams: {
      column: "sellPrice",
      columnType: "number",
    },
    searchType: "quantitative",
  },
];

export const productIndexData = [
  {
    key: "product",
    label: "محصول",
    pluralLabel: "محصولات",
    title: "کالا",
    pageTitle: "محصولات",
    pageDescription: "نمایش کالا و خدمات",
    tableColumns: productTableColumns,
    disableDateFilter: true,
    actions: {
      add: {
        title: "افزودن",
        icon: plusIcon,
        url: "/products/add",
      },
      edit: {},
      fetch: apiGetProducts,
      delete: apiDeleteProducts,
      labelPrint: true,
      excel: {
        export: apiGetProductsExcel,
        import: apiGetProductsExcel,
        exportCategory: apiGetCategoryExcel
      },
      archive: {
        model: 'product'
      }
    },
  },
  {
    key: "service",
    label: "خدمات",
    pluralLabel: "خدمات",
    title: "خدمات",
    pageTitle: "محصولات",
    pageDescription: "نمایش کالا و خدمات",
    tableColumns: serviceTableColumns,
    disableDateFilter: true,
    actions: {
      add: {
        title: "افزودن",
        icon: plusIcon,
        url: "/products/add",
      },
      edit: {},
      fetch: apiGetProducts,
      delete: apiDeleteProducts,
      excel: {
        export: apiGetProductsExcel,
        import: apiGetProductsExcel,
      },
      archive: {
        model: 'product'
      }
    },
  },
];

export const productFormData = {
  key: "product",
  title: "محصول",
  addFunction: apiAddProducts,
  getFunction: apiGetProduct,
  updateFunction: apiUpdateProduct,
  navigation: {
    title: "افزودن محصول",
    // description: "ثبت کالا و خدمات جدید",
    backTitle: "بازگشت",
    backUrl: "/products",
  },
  summaryInfo: {
    key: "product",
    primaryTitleKey: "title",
    addTempTitle: "باز کردن فرم جدید",
    saveTitle: "ذخیره محصولات",
    defaultImage: ImgLogoProduct,
  },
  tabs: [
    {
      key: "product",
      name: "کالا",
      form: {
        main: {
          wrapperClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7",
          imagePicker: {
            active: true,
            type: "imagePicker",
            name: "file",
            wrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-12",
            defaultImage: ImgDefault,
            defaultImageHover: ImgDefaultHover,
            editTitle: "انتخاب عکس",
            editIcon: IconEdit,
            deleteTitle: "حذف",
            deleteIcon: IconDelete,
            addIcon: plus,
          },
          accountingCode: {
            active: true,
            type: "accountingCode",
            name: "accountingCode",
            label: "کد حسابداری",
            primary: true,
            maxLength: 20,
            options: [
              {
                label: "اتوماتیک",
                value: true,
              },
              {
                label: "دستی",
                value: false,
              },
            ],
          },
          status: {
            active: true,
            primary: true,
            name: "active",
            type: "status",
            wrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-12",
          },
          inputs: [
            {
              name: "title",
              label: "نام کالا",
              required: true,
              primary: true,
              maxLength: 128,
            },

            {
              wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12",
              type: "barcode",
              name: "barcode",
              label: "بارکد",
              autoCheckLabel: "ایجاد خودکار بارکد EAN13",
              primary: true,
              maxLength: 32,
            },
            {
              wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12",
              name: "code",
              type: "barcode",
              label: "کد کالا",
              autoCheckLabel: "ایجاد خودکار کد کالا",
              primary: true,
              maxLength: 32,
            },
            {
              wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12 pt-5 pb-5 pr-2",
              type: "checkbox",
              name: "is_public",
              label: "غیر قابل فروش",
              showInput: true,
            },
            {
              type: "category",
              categoryType: "productCategories",
              name: "categoryId",
              label: "دسته بندی",
              primary: true,
              editable: true,
            },
          ],
        },
        tabs: [
          {
            key: "sale",
            name: "قیمت گذاری",
            imgUrl: Document,
            imgUrlShow: DocumentShow,
            inputs: [
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                name: "sellPrice",
                type: "currency",
                noCurrency: true,
                label: "قیمت فروش",
                maxLength: 20,
                showInput: true,
                primary: true,
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                type: "currency",
                noCurrency: true,
                name: "buyPrice",
                label: "قیمت خرید",
                maxLength: 20,
                showInput: true,
                primary: true,
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs position-relative",
                type: "optionalDescription",
                name: "salesDescription",
                label: "افزودن توضیحات",
                maxLength: 128,
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs position-relative",
                type: "optionalDescription",
                name: "buyDescription",
                label: "افزودن توضیحات",
                maxLength: 128,
              },
            ],
          },
          {
            key: "general",
            name: "عمومی",
            imgUrl: Location,
            imgUrlShow: LocationShow,
            inputs: [
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                type: "text",
                name: "unit",
                label: "واحد اصلی",
                maxLength: 16,
                primary: true,
                placeholder: "عدد",
                // disableOnEdit: true,
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs position-relative",
                type: "addUnit",
                name: "secondaryUnit",
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs position-relative",
                name: "mainUnitDescription",
                label: "افزودن توضیحات",
                type: "optionalDescription",
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs position-relative",
                type: "divider",
              },
              {
                wrapperClass:
                  "col-lg-12 col-md-12 col-sm-12 col-xs-12 style-padding-inputs position-relative",
                type: "secondaryUnit",
                name: "secondaryUnit",
                inputs: [
                  {
                    wrapperClass:
                      "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs position-relative",
                    name: "subUnit",
                    label: "واحد فرعی",
                    maxLength: 16,
                    primary: true,
                    placeholder: "کارتن",
                  },
                  {
                    wrapperClass:
                      "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs position-relative",
                    type: "number",
                    name: "conversionRatio",
                    label: "ضریب تبدیل",
                    maxLength: 16,
                    primary: true,
                    placeholder: 24,
                  },
                  {
                    wrapperClass:
                      "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs position-relative",
                    type: "optionalDescription",
                    name: "subUnitDescription",
                    label: "افزودن توضیحات",
                  },
                  {
                    wrapperClass:
                      "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs position-relative",
                    type: "optionalDescription",
                    name: "conversionRatioDescription",
                    label: "افزودن توضیحات",
                  },
                ],
              },
            ],
          },
          {
            key: "inventory",
            name: "سفارش",
            imgUrl: Calling,
            imgUrlShow: CallingShow,
            inputs: [
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                type: "number",
                name: "orderPoint",
                label: "یادآوری سفارش",
                maxLength: 9,
                placeholder: 5,
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                type: "number",
                name: "minOrder",
                label: "حداقل سفارش",
                maxLength: 9,
                placeholder: 10,
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs position-relative",
                type: "optionalDescription",
                name: "orderDescription",
                label: "افزودن توضیحات",
                maxLength: 128,
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs position-relative",
                type: "divider",
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                type: "number",
                name: "waitingTime",
                label: "زمان تحویل (روز)",
                maxLength: 5,
                placeholder: 3,
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                name: "address",
                label: "آدرس کالا",
                placeholder: "راهرو 1 - قفسه 2 - طبقه 3",
              },
            ],
          },
          {
            key: "tax",
            name: "مالیات",
            imgUrl: Calling,
            imgUrlShow: CallingShow,
            inputs: [
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                type: "number",
                name: "saleTax",
                label: "مالیات فروش (درصد)",
                maxLength: 2,
                showInput: true,
                primary: true,
                defaultValue: 9,
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                type: "number",
                name: "buyTax",
                label: "مالیات خرید (درصد)",
                maxLength: 2,
                showInput: true,
                primary: true,
                defaultValue: 9,
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs position-relative",
                type: "optionalDescription",
                name: "saleTaxDescription",
                label: "افزودن توضیحات",
                maxLength: 128,
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs position-relative",
                type: "optionalDescription",
                name: "buyTaxDescription",
                label: "افزودن توضیحات",
                maxLength: 128,
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                type: "number",
                name: "taxCode",
                label: "کد مالیاتی",
                maxLength: 13,
                showInput: true,
                primary: false,
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                name: "taxUnit",
                label: "واحد مالیاتی",
                maxLength: 32,
                showInput: true,
                primary: false,
              },
            ],
          },
          {
            key: "productProperty",
            name: "ویژگی محصول",
            imgUrl: Calling,
            imgUrlShow: CallingShow,
            inputs: [
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                component:ProductPropertyTab,
                type:"custom",
                name: "customElement",
                label: "واحد مالیاتی",
                maxLength: 32,
                showInput: true,
                primary: false,
              },
            ],
          },
        ],
      },
    },
    {
      key: "service",
      name: "خدمات",
      form: {
        main: {
          wrapperClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7",
          imagePicker: {
            active: true,
            type: "imagePicker",
            name: "file",
            wrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-12",
            defaultImage: ImgDefault,
            defaultImageHover: ImgDefaultHover,
            editTitle: "انتخاب عکس",
            editIcon: IconEdit,
            deleteTitle: "حذف",
            deleteIcon: IconDelete,
            addIcon: plus,
          },
          accountingCode: {
            active: true,
            type: "accountingCode",
            name: "accountingCode",
            label: "کد حسابداری",
            primary: true,
            maxLength: 20,
            options: [
              {
                label: "اتوماتیک",
                value: true,
              },
              {
                label: "دستی",
                value: false,
              },
            ],
          },
          status: {
            active: true,
            primary: true,
            name: "active",
            type: "status",
            wrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-12",
          },
          inputs: [
            {
              name: "title",
              label: "نام خدمات",
              required: true,
              primary: true,
              maxLength: 128,
            },
            {
              wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12",
              type: "barcode",
              name: "barcode",
              label: "بارکد",
              primary: true,
              maxLength: 32,
            },
            {
              wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12",
              name: "code",
              label: "کد خدمات",
              primary: true,
              maxLength: 32,
            },
            {
              type: "category",
              categoryType: "serviceCategories",
              name: "categoryId",
              label: "دسته بندی",
              primary: true,
              editable: true,
            },
          ],
        },
        tabs: [
          {
            key: "sale",
            name: "قیمت گذاری",
            imgUrl: Document,
            imgUrlShow: DocumentShow,
            inputs: [
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                name: "sellPrice",
                type: "currency",
                label: "قیمت فروش",
                maxLength: 20,
                showInput: true,
                primary: true,
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs position-relative",
                type: "optionalDescription",
                name: "salesDescription",
                label: "افزودن توضیحات",
                maxLength: 128,
              },
            ],
          },
          {
            key: "general",
            name: "عمومی",
            imgUrl: Location,
            imgUrlShow: LocationShow,
            inputs: [
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                type: "text",
                name: "unit",
                label: "واحد اصلی",
                maxLength: 16,
                primary: true,
                placeholder: "عدد",
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs position-relative",
                name: "mainUnitDescription",
                label: "افزودن توضیحات",
                type: "optionalDescription",
              },
            ],
          },
          {
            key: "tax",
            name: "مالیات",
            imgUrl: Calling,
            imgUrlShow: CallingShow,
            inputs: [
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                type: "number",
                name: "saleTax",
                label: "مالیات فروش (درصد)",
                maxLength: 2,
                showInput: true,
                primary: true,
                defaultValue: 9,
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs position-relative",
                type: "optionalDescription",
                name: "saleTaxDescription",
                label: "افزودن توضیحات",
                maxLength: 128,
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                type: "number",
                name: "taxCode",
                label: "کد مالیاتی",
                maxLength: 13,
                showInput: true,
                primary: false,
              },
              {
                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                name: "taxUnit",
                label: "واحد مالیاتی",
                maxLength: 32,
                showInput: true,
                primary: false,
              },
            ],
          },
        ],
      },
    },
  ],
};
